import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid2 as Grid, Typography } from '@mui/material';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: "100%",
    // padding: "30px"
  },
}));

const Story = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <div>
            <SectionHeader
              title="Our story"
              subtitle=""
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
            />
            <Typography
              variant="body1"
              color="textPrimary"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              className=""
            >
              Sci-Sab (Science Sab Ke Liye) was born from a simple belief—that a society progresses not only through specialists, but through citizens who can think clearly, question thoughtfully, and make informed decisions.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              We saw classrooms where curiosity faded too early and teachers were expected to innovate without adequate support.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }}
              color="textPrimary"
              className=""
            >
              Sci-Sab was created to change that. By enabling scientific enquiry through engaging, curriculum-aligned learning and sustained teacher support, we aim to strengthen the foundation of thinking across generations—because a curious, rational society begins in the classroom.
            </Typography>            
          </div>
        </Grid>
        <Grid
          item
          container
        
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          size={{ xs: 12, md: 6 }}
          data-aos={'fade-up'}
        >
          <Image
            src="/assets/aboutus/story.jpg"
            alt="Our story"

            className={classes.image}
          />
        </Grid>
      </Grid>
    </div>
  );
};

Story.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Story;
